module.exports = __webpack_public_path__ + "img/four.0c3788bc.png";